export default {
    brands: '/about-us/brands',
};
  


// WEBPACK FOOTER //
// ./src/services/app.routes.js